





import {Component, Vue, Watch, Prop } from "vue-property-decorator"

@Component({name:"ui-table-filter"})
export default class UiTableFilterComponent extends Vue{
    
}



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./~/ui-table/src/ui-table-filter.vue